import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';
import { fetchApplicationUserDetailsSuccessAction } from './applicationUser';

export interface GeneralResponse {
    data: GeneralResponseBody;
}
export interface GeneralResponseBody {
    data: Array<QuestionValidationRuleType>;
    limit: number;
    message: string;
    page: number;
    totalCount: number;
    totalPages: number;
    warnings: Array<string>;
    count: number;
}
export interface QuestionValidationRuleType {
    code: string;
    description: string;
    id: string;
    regExExpression: string;
}

export const fetchQuestionValidationRule = createAction<
    fetchQuestionValidationRuleAction | undefined
>(ActionTypes.FETCH_QUESTION_VALIDATION_RULE);
export const fetchQuestionValidationRuleSuccess =
    createAction<fetchQuestionValidationRuleSuccessAction>(
        ActionTypes.FETCH_QUESTION_VALIDATION_RULE_SUCCESS,
    );
export const fetchQuestionValidationRuleFailed =
    createAction<fetchQuestionValidationRuleFailedAction>(
        ActionTypes.FETCH_QUESTION_VALIDATION_RULE_FAILED,
    );

export interface fetchQuestionValidationRuleAction {
    type?: typeof ActionTypes.FETCH_QUESTION_VALIDATION_RULE;
    payload?: undefined;
}

export interface fetchQuestionValidationRuleSuccessAction {
    type: typeof ActionTypes.FETCH_QUESTION_VALIDATION_RULE_SUCCESS;
    body: GeneralResponse;
}

export interface fetchQuestionValidationRuleFailedAction {
    type: typeof ActionTypes.FETCH_QUESTION_VALIDATION_RULE_FAILED;
    payload: GeneralResponse | any;
}
